import { useState, useCallback } from "react";
import { UseTransactionPanelReturn, PanelState } from "./types";
import { CreateTransactionsObject } from "../panels/transactions/types";
import { PanelAction } from "../types";

/**
 * Custom hook to manage transaction panel state (create, edit, duplicate)
 */
export const useTransactionPanel = (): UseTransactionPanelReturn => {
  const [panel, setPanel] = useState<PanelState>({
    action: "create",
    isOpen: false,
    transaction: undefined,
  });

  const openPanel = useCallback(
    (action: PanelAction, transaction?: CreateTransactionsObject) => {
      setPanel({
        action,
        isOpen: true,
        transaction,
      });
    },
    [],
  );

  const closePanel = useCallback(() => {
    setPanel((prev) => ({
      ...prev,
      isOpen: false,
      transaction: undefined,
    }));
  }, []);

  return {
    panel,
    openPanel,
    closePanel,
  };
};
